export enum KeywayType {
    Elevated = 1,
    PlugOrCylinder = 2,
    Plug = 3,
  }
